import { Box, Grid } from "@mui/material";
import { useEffect } from "react";
import { apiVariable } from "../../api/apiVariable";
import * as signalR from "@microsoft/signalr";
import useAuth from "../../hooks/useAuth";
import { useQueryClient } from "@tanstack/react-query";
import "../../assets/styles/pages/Fleet/incidentsPage.css";
import YardRepairPopup from "../../components/Fleet/YardRepairPopup/YardRepairPopup";
import YardRepairsTable from "../../components/Fleet/YardRepairsTable/YardRepairsTable";
import GenerateAllAssetRepairsButton from "../../components/Fleet/GeneratePdfButtons/GenerateAllAssetRepairsButton/GenerateAllAssetRepairsButton";

const YardRepairsPage: React.FC = () => {
  const { token } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    const yardRepairsConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${apiVariable}/yardRepairHub`, {
        accessTokenFactory: () => token || "",
        withCredentials: false,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.None)
      .build();

    yardRepairsConnection.on("YardRepairUpdated", () => {
      queryClient.invalidateQueries({ queryKey: ["yardRepairs"] });
    });

    yardRepairsConnection.start();

    return () => {
      yardRepairsConnection.stop();
    };
  }, [token, queryClient]);

  return (
    <Box className="incidents-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "600px" }}
            >
              <Grid item>
                <YardRepairPopup />
              </Grid>
              <Grid item>
                <GenerateAllAssetRepairsButton
                  token={token}
                  incidentsRepairsOnly={false}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <YardRepairsTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default YardRepairsPage;
